import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supabase } from '../lib/supabase'
import { ErrorAlert } from '../components/ui'

export default function ForgotPassword() {
  const { t } = useTranslation('auth')
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + '/reset-password',
      })
      if (error) throw error
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md animate-fadeIn">
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl font-medium text-gray-800 mb-2">
            {t('forgotPassword.title')}
          </h1>
          <p className="text-gray-500">{t('forgotPassword.subtitle')}</p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-sm">
          {sent ? (
            <div className="text-center">
              <div className="w-14 h-14 bg-primary-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-7 h-7 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="font-display text-xl font-medium text-gray-800 mb-2">
                {t('forgotPassword.checkEmailTitle')}
              </h2>
              <p className="text-gray-500 mb-6">
                {t('forgotPassword.checkEmailMessage')} <strong className="text-gray-700">{email}</strong>
              </p>
              <Link
                to="/login"
                className="text-primary-600 font-semibold hover:underline"
              >
                {t('forgotPassword.backToLogin')}
              </Link>
            </div>
          ) : (
            <>
              <p className="text-gray-500 text-sm mb-5">
                {t('forgotPassword.instruction')}
              </p>

              <ErrorAlert message={error} onDismiss={() => setError(null)} />

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block font-semibold text-gray-800 mb-2">{t('forgotPassword.emailLabel')}</label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg text-base transition-all focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t('forgotPassword.emailPlaceholder')}
                    required
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white rounded-xl font-semibold transition-all hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {loading ? t('forgotPassword.sending') : t('forgotPassword.sendResetLink')}
                </button>
              </form>

              <div className="text-center mt-5">
                <Link
                  to="/login"
                  className="text-primary-600 text-sm font-semibold hover:underline"
                >
                  {t('forgotPassword.backToLogin')}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
